// extracted by mini-css-extract-plugin
module.exports = {"main_subtitle":"Funciones__main_subtitle__1-N8j","slash":"Funciones__slash__2zp-H","my_btn":"Funciones__my_btn__Pps2J"};